import { render, staticRenderFns } from "./BannerPrincipalCampanha.vue?vue&type=template&id=280f9e8a&scoped=true"
import script from "./BannerPrincipalCampanha.vue?vue&type=script&lang=js"
export * from "./BannerPrincipalCampanha.vue?vue&type=script&lang=js"
import style0 from "./BannerPrincipalCampanha.vue?vue&type=style&index=0&id=280f9e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280f9e8a",
  null
  
)

export default component.exports